import { Dispatch, SetStateAction, useState } from "react";
import { GetApiData, PostApiData } from "../api/general";
import { ROUTES } from "../constants/api";
import { GetCardShowDetailsResponse, GetMyCardResponse } from "../types/api/card";

export type ActiveModal = "pin" | "cardDetails" | "directive" | "setupFaceCheck" | null;

export const useMyCardModals = (
  data: GetMyCardResponse,
  openErrorModal: (err: unknown) => void
) => {
  const [activeModal, setActiveModal] = useState<ActiveModal>(null);
  const [cardDetails, setCardDetails] = useState<GetCardShowDetailsResponse | null>(null);
  const [submitting, setSubmitting] = useState(false);

  const setModalOpen =
    (modal: Exclude<ActiveModal, null>): Dispatch<SetStateAction<boolean>> =>
      (value) =>
        setActiveModal((current) => {
          const next = typeof value === "function" ? value(current === modal) : value;
          return next ? modal : current === modal ? null : current;
        });

  const submitPin = async (pin: string) => {
    setSubmitting(true);
    try {
      await PostApiData(ROUTES.CARD.VERIFY_CURRENT_PIN(data.cardId), { pin });
      const details = await GetApiData<GetCardShowDetailsResponse>(
        ROUTES.CARD.GET_CARD_SHOW_DETAILS(data.cardId)
      );
      setCardDetails(details);
      setActiveModal("cardDetails");
    } catch (err) {
      openErrorModal(err);
    } finally {
      setSubmitting(false);
    }
  };

  return { activeModal, setActiveModal, setModalOpen, cardDetails, submitting, submitPin };
};